/** @jsx jsx */
import { Box, Container, Grid, Heading, jsx, Text } from 'theme-ui'
import ContentFaqTopic from '~/components/Content/Faq/Topic'
import StructuredFaqPageData from '~/components/StructuredData/FaqPage'

const FaqPageSection = ({ description, title, topics }) => {
  return (
    <Box pb={[7, 14]}>
      <StructuredFaqPageData
        questions={topics.reduce(
          (questions, topic) => [...questions, ...topic.questions],
          []
        )}
      />
      <Box py={[7, null, 9]}>
        <Container>
          <Grid columns={[1, 12]}>
            <Box
              sx={{
                gridColumn: [null, '2 / 12', '3 / 11'],
                textAlign: 'center',
              }}
            >
              <Heading as="h1" variant="title1" mb={2}>
                {title}
              </Heading>
              {description && (
                <Box
                  variant="text.body1"
                  sx={{
                    p: {
                      m: 0,
                    },
                    a: {
                      variant: 'text.link',
                    },
                  }}
                  dangerouslySetInnerHTML={{
                    __html: description.childMarkdownRemark.html,
                  }}
                />
              )}
            </Box>
          </Grid>
        </Container>
      </Box>
      <Container>
        <Grid columns={[1, null, 12]} sx={{ rowGap: '0' }}>
          <Box sx={{ gridColumn: [null, null, '1 / 6'] }}>
            <Box
              bg="backgroundDark"
              mx={['-16px', '-24px']}
              mr={[null, null, '0']}
              mb={[5, 7, 0]}
              pt={[5]}
              pb={[6]}
              px={[2, 3]}
              sx={{
                position: [null, null, 'sticky'],
                top: [null, null, '128px'],
              }}
            >
              <Text as="p" variant="subtitle2" mb={[2, null, 3]}>
                {'Categories'}
              </Text>
              <Grid columns={[1, 2, 1]} mb="-16px" sx={{ rowGap: '0' }}>
                {topics.map((topic) => (
                  <Text key={`cat-${topic.id}`} as="p" variant="title4" mb={2}>
                    <a
                      href={`#${topic.slug}`}
                      sx={{
                        color: 'black',
                        textDecoration: 'none',
                        '&:hover': { textDecoration: 'underline' },
                      }}
                    >
                      {topic.name}
                    </a>
                  </Text>
                ))}
              </Grid>
            </Box>
          </Box>
          <Box sx={{ gridColumn: [null, null, '6 / -1'] }}>
            {topics.map((topic) => {
              return (
                <Box key={`qa-${topic.id}`} mb={[5, 9]}>
                  <ContentFaqTopic topic={topic} />
                </Box>
              )
            })}
          </Box>
        </Grid>
      </Container>
    </Box>
  )
}

export default FaqPageSection
